import type {
  CrmCollaborationAccessStatus,
  CrmCollaborationAssignmentMode,
  CrmCollaborationTargetType,
  CrmCollaborationTaskStatus,
  CrmCollaborationTaskType,
} from "../types";

export const crmCollaborationTaskQueryRootKey = ["crm-collaboration-task"] as const;

export const taskTypeLabels: Record<CrmCollaborationTaskType, string> = {
  tele_sales: "电销",
  strong_follow: "强跟",
  data_clean: "数据清洗",
  revisit: "回访",
};

export const targetTypeLabels: Record<CrmCollaborationTargetType, string> = {
  contact: "联系人",
};

export const assignmentModeLabels: Record<CrmCollaborationAssignmentMode, string> = {
  pool: "公共池",
  specified: "指定处理人",
  mixed: "混合",
};

export const taskStatusLabels: Record<CrmCollaborationTaskStatus, string> = {
  draft: "草稿",
  validating: "已校验",
  active: "已发布",
  closed: "已关闭",
  cancelled: "已取消",
};

export const accessStatusLabels: Record<CrmCollaborationAccessStatus, string> = {
  available: "可认领",
  assigned: "已指定",
  claimed: "已认领",
  released: "已释放",
  cancelled: "已取消",
};
